import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { getIsRecording } from '~/store/duck/audioRecorder'

/**
 * Navigation guard for active recording sessions.
 * Shows browser-native warning when user tries to close/refresh tab during recording.
 * Does NOT intercept navigation - users can navigate freely while recording.
 */
export const useAudioRecorderNavigationGuard = () => {
  const isRecording = useSelector(getIsRecording)

  useEffect(() => {
    if (!isRecording) {
      return undefined
    }

    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      // Browser-native warning for tab close/refresh
      e.preventDefault()
      e.returnValue = '' // Required for Chrome
    }

    window.addEventListener('beforeunload', handleBeforeUnload)

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [isRecording])
}
